import moment from 'moment';
import numeral from 'numeral';
//import 'numeral/locales/en-gb';
//numeral.locale('en-gb');

const util = {
    format: {
        date: (date: any) => {
            return moment(date).format('DD-MM-YYYY');
        },
        USDate: (date: any) => {
            return moment(date).format('MM/DD/YYYY');
        },
        systemDate: (date: any) => {
            return moment(date).format('YYYY/MM/DD');
        },

        datetime: (date: any) => {
            return moment(date).format('DD MMM, YYYY h:mm:ss a');
        },
        durationUntilNow: (seconds: any) => {
            let year = Math.floor(seconds / 31536000);
            seconds = seconds % 31536000;
            let minute = Math.floor(seconds / 60);
            seconds = seconds % 60;
            let hour = Math.floor(minute / 60);
            minute = minute % 60;
            let day = Math.floor(hour / 24);
            hour = hour % 24;
            let str = '';
            str += (year > 0) ? year.toString().padStart(2, '0') + 'Y ' : '';
            str += (day > 0) ? day.toString().padStart(2, '0') + 'D ' : '';
            str += (hour > 0) ? hour.toString().padStart(2, '0') + ':' : '00:';
            str += (minute > 0) ? minute.toString().padStart(2, '0') + ':' : '00:';
            str += (seconds > 0) ? seconds.toString().padStart(2, '0') + '' : '00';
            return str
        },
        seconds: (seconds: any) => {
            let year = Math.floor(seconds / 31536000);
            seconds = seconds % 31536000;
            let minute = Math.floor(seconds / 60);
            seconds = seconds % 60;
            let hour = Math.floor(minute / 60);
            minute = minute % 60;
            let day = Math.floor(hour / 24);
            hour = hour % 24;
            let str = '';
            str += (year > 0) ? year.toString().padStart(2, '0') + 'Y ' : '';
            str += (day > 0) ? day.toString().padStart(2, '0') + 'D ' : '';
            str += (hour > 0) ? hour.toString().padStart(2, '0') + ':' : '00:';
            str += (minute > 0) ? minute.toString().padStart(2, '0') + ':' : '00:';
            str += (seconds > 0) ? seconds.toString().padStart(2, '0') + '' : '00';
            return str
        },
        time: (date: any) => {
            return moment(date).format('h:mm:ss a');
        },
        MM_YYYY: (date: any) => {
            return moment(date).format('MMMM, YYYY');
        },
        currency: (val: any) => {
            return numeral(val).format('$0,0.00');
        },
        currencyWithoutDecimal: (val: any) => {
            return numeral(val).format('$0,0;($0,0)');
        },
        paramCost: (val: any) => {
            return numeral(val).format('$0,0.000');
        },
        unitPrice: (val: any) => {
            return numeral(val).format('$0,0.0000');
        }
    },
    date: {
        today: () => {
            return moment().format('YYYY-MM-DD');
        },
        todatetime: () => {
            return moment().format('YYYY-MM-DD-H:MM:ss');
        },
        toDate: (date: any) => { return moment(date).toDate() },
        oneMonthAhead: () => {
            return moment().add(30, 'days').format('YYYY-MM-DD');
        },
        daysInMonth: (month) => {
            return moment().set('month', (month - 1)).daysInMonth();

        },
        currentYear: () => {
            return moment().format('YYYY');
        },
        currentMonth: () => {
            return moment().format('MM');
        },
        currentDay: () => {
            return moment().format('DD');
        },
    },
    ifNull: (val: string, dval: string = '') => {
        return (val == null || val == undefined) ? (dval ? dval : '') : val;
    },
    utc: (date: any) => {
        return moment(date).utc().format('MM/DD/YYYY')
    },
    utcOff: (date: any) => {
        return moment(date).utcOffset(date).format('MM/DD/YYYY')
    }

}

export default util;